import React, { useLayoutEffect, useEffect } from 'react';
import NotificationBell from '../../../components/notification/NotificationBell';
import { useTranslation } from 'react-i18next';
import Header, { HeaderLeft, HeaderRight } from '../../../layout/Header/Header';
import Button from '../../../components/bootstrap/Button';
import useDarkMode from '../../../hooks/useDarkMode';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from '../../../components/bootstrap/Dropdown';
import Icon from '../../../components/icon/Icon';
import Breadcrumb from '../../../components/bootstrap/Breadcrumb';
import { useBranch } from '../../../contexts/branchContext';
import { API_BASE_URL } from '../../../local';

const DashboardHeader = () => {
	const { darkModeStatus } = useDarkMode();
	const { i18n } = useTranslation();
	const { activeBranch, setActiveBranch, branches, setBranches, userBranchId } = useBranch();

	const getUserData = () => {
		const storedData = localStorage.getItem("userdata");
		if (storedData) {
			try {
				return JSON.parse(storedData);
			} catch (error) {
				console.error("Failed to parse userdata:", error);
				return null;
			}
		}
		return null;
	};

	// Fetch all branches for SUPER_ADMIN branch selector
	useEffect(() => {
		const storedUser = localStorage.getItem('userdata');
		if (!storedUser) return;
		try {
			const user = JSON.parse(storedUser);
			if (user.role === 'SUPER_ADMIN') {
				const token = localStorage.getItem('token');
				fetch(`${API_BASE_URL}/settings/branch/read?token=${token}&limit=100`)
					.then(r => r.json())
					.then(result => {
						if (result.success) {
							setBranches(result.data);
							if (!activeBranch && userBranchId) {
								const defaultBranch = result.data.find((b: any) => b.id === userBranchId);
								if (defaultBranch) setActiveBranch(defaultBranch);
							}
						}
					})
					.catch(console.error);
			}
		} catch { /* ignore */ }
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	useLayoutEffect(() => {
		document.documentElement.setAttribute('lang', i18n.language);
	});

	const handleBranchChange = (branch: any) => {
		setActiveBranch(branch);
		window.location.reload();
	};

	// Check if current user is SUPER_ADMIN
	const storedUser = getUserData();
	const isSuperAdmin = storedUser?.role === 'SUPER_ADMIN';

	return (
		<Header mobileRightExtra={<NotificationBell />}>
			<HeaderLeft className="d-flex align-items-center gap-3">
				<Breadcrumb />
				{isSuperAdmin && branches.length > 0 && (
					<Dropdown>
						<DropdownToggle hasIcon={false}>
							<Button
								color={darkModeStatus ? 'dark' : 'light'}
								isLight={!darkModeStatus}
								size="sm"
								icon="Business"
							>
								{activeBranch?.name || 'Select Branch'}
							</Button>
						</DropdownToggle>
						<DropdownMenu>
							{branches.map((b) => (
								<DropdownItem
									key={b.id}
									onClick={() => handleBranchChange(b)}
								>
									<div>
										<Icon icon={activeBranch?.id === b.id ? 'CheckBox' : 'CheckBoxOutlineBlank'} size="sm" className="me-2" />
										{b.name}
									</div>
								</DropdownItem>
							))}
						</DropdownMenu>
					</Dropdown>
				)}
				{getUserData()?.employe_name}
			</HeaderLeft>
			<HeaderRight>
				<span className="d-none d-md-inline-block">
					<NotificationBell />
				</span>
			</HeaderRight>
		</Header>
	);
};

export default DashboardHeader;
